import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PETITION_STARTER_MEDIA_INQUIRY = createFcmDetails('petition_starter_media_inquiry', {
	owner: 'Campaigns',
	context: 'Petition Page',
	description:
		'This FC controls showing the petition starter media inquiry button and the url link on the Petition page',
	template: {
		enabled: false,
		url: '',
	},
	import: false,
});
